/**
 * Industry Template schemas — Spec Bölüm 11
 */
import { z } from 'zod';
import { DifficultySchema, IndustrySchema, TopicSchema } from './common.js';

/** Topic weights — toplam 1.0 olmalı */
export const TopicWeightsSchema = z
  .record(TopicSchema, z.number().min(0).max(1))
  .refine(
    (w) => {
      const sum = Object.values(w).reduce((acc, v) => acc + (v ?? 0), 0);
      return Math.abs(sum - 1.0) < 0.01;
    },
    { message: 'Topic weights toplamı 1.0 olmalı' },
  );

export type TopicWeights = z.infer<typeof TopicWeightsSchema>;

/** Zorluk dağılımı — toplam 1.0 olmalı */
export const DifficultyDistributionSchema = z
  .record(DifficultySchema, z.number().min(0).max(1))
  .refine(
    (d) => {
      const sum = Object.values(d).reduce((acc, v) => acc + (v ?? 0), 0);
      return Math.abs(sum - 1.0) < 0.01;
    },
    { message: 'Difficulty distribution toplamı 1.0 olmalı' },
  );

export type DifficultyDistribution = z.infer<typeof DifficultyDistributionSchema>;

/** Full industry template */
export const IndustryTemplateSchema = z.object({
  slug: z.string().min(1).max(50),
  name: z.string().min(1).max(200),
  targetIndustries: z.array(IndustrySchema).min(1),
  description: z.string().optional(),
  exampleIndustries: z.array(z.string()).default([]),
  durationMin: z.number().int().min(15).max(240).default(90),
  questionCount: z.number().int().min(5).max(50).default(25),
  topicWeights: TopicWeightsSchema,
  difficultyDistribution: DifficultyDistributionSchema,
  emphasizedSubtopics: z.array(z.string()).default([]),
});

export type IndustryTemplate = z.infer<typeof IndustryTemplateSchema>;
